<template>
    <div>
        <section class="content-header">
            <h1>
                <span>{{ $ml.get('shared.inventories') }}</span>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <i class="fa fa-dashboard"></i>
                    <span>{{ $ml.get('shared.inventoryManagement') }}</span>
                </li>
                <li>
                    <i class="fa fa-box"></i>
                    <span>{{ $ml.get('shared.inventories') }}</span>
                </li>
            </ol>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-sm-3">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">
                                <span>{{ $ml.get('inventoryManagement.inventoryList') }}</span>
                            </h3>
                            <div class="box-tools pull-right"></div>
                        </div>
                        <div class="box-body">
                            <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText"
                                class="form-control" autocomplete="false" style="margin-bottom:10px;" />
                            <select class="form-control" v-model="selectedCategory" style="margin-bottom:10px;">
                                <option :value="0">{{ $ml.get('inventoryManagement.allCategories') }}</option>
                                <option v-for="category in inventoryCategoryList" :key="category.id"
                                    :value="category.id">{{ category.name }}</option>
                            </select>
                            <div v-show="inventoryList.length > 0" class="table-responsive no-padding"
                                :style="windowHeightSize">
                                <table class="table table-hover">
                                    <tbody>
                                        <tr v-for="inventory in inventoryList" :key="inventory.id">
                                            <td>
                                                <span>{{ inventory.name }}</span><br />
                                                <small class="text-muted">{{ inventory.code }}</small>
                                            </td>
                                            <td>
                                                <button class="btn btn-primary btn-sm"
                                                    @click="getInventory(inventory.id)">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr></tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-show="inventoryList.length == 0" class="callout callout-info">
                                <i class="fa fa-info-circle"></i> {{ $ml.get('alerts.recordNotFound') }}
                            </div>
                        </div>
                        <div class="overlay" id="load" :hidden="!isLoading">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div class="col-sm-9">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <h3 class="box-title">
                                <span>{{ $ml.get('inventoryManagement.inventoryInfo') }}</span>
                            </h3>
                            <div class="box-tools pull-right">
                                <button v-show="authControl == 0" @click="newInventory()" type="button"
                                    class="btn btn-sm btn-warning ">{{ $ml.get('inventoryManagement.newInventory')
                                    }}</button>
                            </div>
                        </div>
                        <div class="box-body" align="center">
                            <div class="row">
                                <div v-show="inventory.id" class="col-sm-3">
                                    <div class="box box-primary">
                                        <div class="box-body box-profile">
                                            <img class="profile-user-img img-responsive"
                                                :src="inventory.photoUrl == null ? '/src/assets/default-product.png' : inventory.photoUrl"
                                                style="width:100%;" />
                                            <hr />
                                            <input type="file" ref="imageFile" id="image" @change="addPhoto"
                                                style="display:none;" class="form-control" accept=".png, .jpg, .jpeg"
                                                hidden />
                                            <button v-show="inventory.photoUrl" type="button" @click="removeImage()"
                                                class="btn btn-danger btn-sm" style="width:100%;margin-bottom:5px;">
                                                <i class="fa fa-remove"></i>
                                                {{ $ml.get('inventoryManagement.removePhoto') }}
                                            </button>
                                            <button type="button" @click="$refs.imageFile.click()"
                                                class="btn btn-primary btn-sm" style="width:100%">
                                                <i class="fa fa-upload"></i>
                                                {{ $ml.get('inventoryManagement.selectPhoto') }}
                                            </button>
                                            <hr />
                                            <p class="text-center">
                                                <span class="text-muted" style="font-size: 12px;">{{ inventory.code
                                                }}</span><br />
                                                <span>{{ inventory.name }}</span><br />
                                                <span style="font-style: italic;font-size: 12px;">{{
                                                    getInventoryCategoryName(inventory.categoryId) }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div :class="inventory.id ? 'col-md-9' : 'col-md-12'">
                                    <div class="nav-tabs-custom">
                                        <ul class="nav nav-tabs">
                                            <li class="active" id="temel-bilgiler-tab">
                                                <a href="#temel-bilgiler" data-toggle="tab" aria-expanded="true">
                                                    {{ $ml.get('employees.generalInformation') }}
                                                </a>
                                            </li>
                                            <li v-show="inventory.id" id="ozellikler-tab">
                                                <a href="#ozellikler" data-toggle="tab"
                                                    aria-expanded="true">Özellikler</a>
                                            </li>
                                            <li v-show="inventory.id" id="belgeler-tab">
                                                <a href="#belgeler" data-toggle="tab" aria-expanded="true">Belgeler</a>
                                            </li>
                                            <li v-show="inventory.id" id="zimmetlenen-kisiler-tab">
                                                <a href="#zimmetlenen-kisiler" data-toggle="tab"
                                                    aria-expanded="true">Zimmetlenen Kişiler</a>
                                            </li>
                                        </ul>
                                        <div class="tab-content">
                                            <div class="tab-pane active" id="temel-bilgiler">
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-3">
                                                        <h5>
                                                            <span>{{ $ml.get('inventoryManagement.inventoryCode')
                                                                }}</span> :
                                                        </h5>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <input type="text" v-model="inventory.code"
                                                            class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-3">
                                                        <h5>
                                                            <span>{{ $ml.get('inventoryManagement.inventoryName')
                                                                }}</span> :
                                                        </h5>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <input type="text" v-model="inventory.name"
                                                            class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-3">
                                                        <h5>
                                                            <span>{{
                                                                $ml.get('inventoryManagement.inventorySerialNo')
                                                                }}</span> :
                                                        </h5>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <input type="text" v-model="inventory.serialNo"
                                                            class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-3">
                                                        <h5>
                                                            <span>{{
                                                                $ml.get('inventoryManagement.inventoryCategory')
                                                                }}</span> :
                                                        </h5>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <select class="form-control" @change="changeCategory($event)">
                                                            <option :selected="inventory.categoryId == 0" :value="0">{{
                                                                $ml.get('general.notSelected') }}</option>
                                                            <option v-for="category in inventoryCategoryList"
                                                                :key="category.id"
                                                                :selected="category.id == inventory.categoryId"
                                                                :value="category.id">{{ category.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-3">
                                                        <h5>
                                                            <span>{{
                                                                $ml.get('inventoryManagement.inventoryDefaultWarehouse')
                                                                }}</span> :
                                                        </h5>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <select class="form-control"
                                                            @change="changeDefaultWarehouse($event)">
                                                            <option :selected="inventory.defaultWarehouseId == 0"
                                                                :value="0">{{
                                                                    $ml.get('general.notSelected') }}</option>
                                                            <option v-for="warehouse in inventoryWarehouseList"
                                                                :key="warehouse.id"
                                                                :selected="warehouse.id == inventory.defaultWarehouseId"
                                                                :value="warehouse.id">{{ warehouse.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-3">
                                                        <h5>
                                                            <span>{{ $ml.get('inventoryManagement.quantity')
                                                                }}</span> :
                                                        </h5>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <input type="number" v-model="inventory.quantity" min="0"
                                                            class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="row" v-show="inventory.id" style="margin-top:10px;">
                                                    <div class="col-sm-12">
                                                        <hr />
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="box box-primary"
                                                            style="min-height:90px;margin-bottom:15px;">
                                                            <div class="box-body">
                                                                <div style="text-align: start;">
                                                                    <span>Toplam: <strong>{{ inventory.quantity
                                                                    }}</strong></span><br />
                                                                    <span>Zimmetlenen: <strong>{{
                                                                        inventory.assignedCount
                                                                    }}</strong></span><br />
                                                                    <span>Kalan: <strong>{{ inventory.quantity -
                                                                        inventory.assignedCount
                                                                    }}</strong></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="info-box bg-blue" v-show="inventory.id">
                                                            <div class="info-box-content" style="margin-left: 0px;">
                                                                <span class="info-box-text"
                                                                    style="text-transform: none;">Zimmet Oranı</span>
                                                                <span class="info-box-number">%{{
                                                                    (inventory.assignedCount * 100 / inventory.quantity)
                                                                }}</span>

                                                                <div class="progress">
                                                                    <div class="progress-bar"
                                                                        :style="'width:' + inventory.assignedCount * 100 / inventory.quantity + '%'">
                                                                    </div>
                                                                </div>
                                                                <span class="progress-description"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="ozellikler" v-show="inventory.id">
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-4">
                                                        <select class="form-control" @change="changeField($event)">
                                                            <option :selected="newFieldId == 0" :value="0">{{
                                                                $ml.get('general.notSelected') }}</option>
                                                            <option v-for="field in inventoryFieldList" :key="field.id"
                                                                :value="field.id" :selected="newFieldId == field.id">{{ field.name
                                                                }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <input type="text" v-model="newFieldValue" class="form-control"
                                                            placeholder="Değer Giriniz" />
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <button type="button" @click="addField()"
                                                            class="btn btn-primary btn-sm" style="width: 100%;">
                                                            <i class="fa fa-plus"></i>
                                                            {{ $ml.get('general.add') }}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-12">
                                                        <table class="table table-hover" style="margin-top:10px;">
                                                            <tbody>
                                                                <tr v-for="(field, key) in inventory.fields"
                                                                    :key="'field' + key">
                                                                    <td>{{ field.fieldName }}</td>
                                                                    <td>{{ field.fieldValue }}</td>
                                                                    <td>
                                                                        <button type="button" @click="deleteField(field.fieldValueId)"
                                                                            class="btn btn-danger btn-sm">
                                                                            <i class="fa fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr
                                                                    v-if="inventory.id != null && inventory.fields.length == 0">
                                                                    <td colspan="3" class="text-center">
                                                                        <span>{{ $ml.get('alerts.recordNotFound') }}</span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="belgeler" v-show="inventory.id">
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-12">
                                                        <button type="button" @click="newDocument()"
                                                            class="btn btn-primary btn-sm" style="width: 100%;">
                                                            <i class="fa fa-upload"></i>
                                                            Yeni Belge Yükle
                                                        </button>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <table class="table table-hover" style="margin-top:10px;">
                                                            <thead>
                                                                <tr>
                                                                    <th>{{
                                                                        $ml.get('inventoryManagement.documentType')
                                                                        }}</th>
                                                                    <th>{{
                                                                        $ml.get('inventoryManagement.documentDescription')
                                                                        }}</th>
                                                                    <th></th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="document in documentList" :key="document.id">
                                                                    <td>{{
                                                                        getDocumentDefinitionName(document.documentDefinitionId)
                                                                        }}</td>
                                                                    <td>{{ document.description }}</td>
                                                                    <td>
                                                                        <button v-if="!document.filePath"
                                                                            class="btn btn-primary btn-sm"
                                                                            @click="uploadDocumentDialog(document)">
                                                                            <i class="fa fa-upload"></i> Dosya Yükle
                                                                        </button>
                                                                        <a v-if="document.filePath"
                                                                            :href="document.filePath" target="_blank"
                                                                            class="btn btn-success btn-sm">
                                                                            <i class="fa fa-download"></i> Dosya
                                                                            İndir
                                                                        </a>
                                                                    </td>
                                                                    <td>
                                                                        <button class="btn btn-primary btn-sm"
                                                                            @click="getDocument(document)">
                                                                            <i class="fa fa-pencil"></i>
                                                                        </button>
                                                                        <button class="btn btn-danger btn-sm"
                                                                            @click="deleteDocument(document.id)">
                                                                            <i class="fa fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr
                                                                    v-if="inventory.id != null && documentList.length == 0">
                                                                    <td colspan="4" class="text-center">
                                                                        <span>{{ $ml.get('alerts.recordNotFound')
                                                                            }}</span>
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="inventory.id == null">
                                                                    <td colspan="4" class="text-center">
                                                                        <span>{{ $ml.get('alerts.pleaseSelect')
                                                                            }}</span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="zimmetlenen-kisiler" v-show="inventory.id">
                                                <div class="row" style="margin-top:10px;">
                                                    <div class="col-sm-12">
                                                        <table class="table table-hover" style="margin-top:10px;">
                                                            <thead>
                                                                <tr>
                                                                    <th>Kişi Bilgisi</th>
                                                                    <th>Adet</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(assignedPerson, key) in inventory.assignedUsers"
                                                                    :key="key">
                                                                    <td>{{ assignedPerson.name }}<span
                                                                            v-show="assignedPerson.isVisitor">
                                                                            (Ziyaretçi)</span></td>
                                                                    <td>{{ assignedPerson.quantity }}</td>
                                                                </tr>
                                                                <tr
                                                                    v-if="inventory.id != null && inventory.assignedCount == 0">
                                                                    <td colspan="2" class="text-center">
                                                                        <span>{{ $ml.get('alerts.recordNotFound')
                                                                            }}</span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="overlay" id="load" :hidden="!isLoadingDetail">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                        <div class="box-footer">
                            <div class="pull-right">
                                <button v-show="inventory.id && authControl == 0" type="button" data-toggle="modal"
                                    data-target="#modal-sil" class="btn btn-sm btn-danger "
                                    style="margin: 5px; width:120px;">{{ $ml.get('general.delete') }}</button>
                                <button v-show="!inventory.id && authControl == 0" type="button" data-toggle="modal"
                                    data-target="#modal-kaydet" class="btn btn-sm btn-success "
                                    style="margin: 5px; width:120px;">{{ $ml.get('general.save') }}</button>
                                <button v-show="inventory.id && authControl == 0" type="button" data-toggle="modal"
                                    data-target="#modal-guncelle" class="btn btn-sm btn-success "
                                    style="margin: 5px; width:120px;">{{ $ml.get('general.update') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.MODAL START-->
            <div class="modal fade" id="modal-document">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span v-if="!document.id">{{ $ml.get('inventoryManagement.newDocument') }}</span>
                                <span v-if="document.id">{{ $ml.get('inventoryManagement.editDocument') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label>{{ $ml.get('inventoryManagement.documentType') }}</label>
                                    <select class="form-control" v-model="document.documentDefinitionId">
                                        <option :selected="document.documentDefinitionId == null" :value="null">{{
                                            $ml.get('general.notSelected') }}</option>
                                        <option v-for="definition in documentDefinitionList" :key="definition.id"
                                            :selected="definition.id == document.documentDefinitionId"
                                            :value="definition.id">{{ definition.name }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-12" style="margin-top:10px;">
                                    <label>{{ $ml.get('inventoryManagement.documentDescription') }}</label>
                                    <input type="text" v-model="document.description" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-dismiss="modal">
                                <i class="fa fa-remove"></i>
                                <span>{{ $ml.get('general.cancel') }}</span>
                            </button>
                            <button @click="saveDocument()" class="btn btn-success" data-dismiss="modal">
                                <i class="fa fa-check"></i>
                                <span>{{ $ml.get('general.save') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.MODAL END -->
            <!-- /.MODAL START-->
            <div class="modal fade" id="modal-document-file">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('inventoryManagement.addDocumentFile') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input type="file" ref="file" id="fileName" @change="uploadFile"
                                        class="form-control"
                                        accept=".zip, .pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-dismiss="modal">
                                <i class="fa fa-remove"></i>
                                <span>{{ $ml.get('general.cancel') }}</span>
                            </button>
                            <button @click="submitFile()" class="btn btn-info" data-dismiss="modal">
                                <i class="fa fa-upload"></i>
                                <span>{{ $ml.get('general.upload') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.MODAL END -->
            <!-- /.MODAL START-->
            <div class="modal modal-info fade" id="modal-guncelle">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('general.update') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div>
                                <span>{{ this.inventory.name }}</span>
                            </div>
                            <br />
                            <p></p>
                            <span>{{ $ml.get('inventoryManagement.isContinueInventoryUpdate') }}</span>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-dismiss="modal">
                                <i class="fa fa-remove"></i>
                                <span>{{ $ml.get('general.cancel') }}</span>
                            </button>
                            <button @click="saveInventory()" class="btn btn-info" data-dismiss="modal">
                                <i class="fa fa-refresh"></i>
                                <span>{{ $ml.get('general.update') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.MODAL END -->
            <!-- /.MODAL START-->
            <div class="modal modal-success fade" id="modal-kaydet">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('general.save') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <p>{{ this.inventory.name }}</p>
                            <span>{{ $ml.get('inventoryManagement.isContinueInventorySave') }}</span>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-dismiss="modal">
                                <i class="fa fa-remove"></i>
                                <span>{{ $ml.get('general.cancel') }}</span>
                            </button>
                            <button @click="saveInventory()" class="btn btn-success" data-dismiss="modal">
                                <i class="fa fa-check"></i>
                                <span>{{ $ml.get('general.save') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.MODAL END -->
            <!-- /.MODAL START-->
            <div class="modal modal-danger fade" id="modal-sil">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('general.delete') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div>
                                <span>{{ this.inventory.name }}</span>
                            </div>
                            <br />
                            <p></p>
                            <span>{{ $ml.get('inventoryManagement.isContinueInventoryDelete') }}</span>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-dismiss="modal">
                                <i class="fa fa-remove"></i>
                                <span>{{ $ml.get('general.cancel') }}</span>
                            </button>
                            <button @click="deleteInventory()" class="btn btn-danger" data-dismiss="modal">
                                <i class="fa fa-trash"></i>
                                <span>{{ $ml.get('general.delete') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.MODAL END -->
        </section>
    </div>
</template>

<script>
import { data } from 'qrcode.vue';

export default {
    data() {
        return {
            windowHeight: window.innerHeight,
            isLoading: false,
            isLoadingDetail: false,
            searchText: "",
            selectedCategory: 0,
            inventory: {
                id: null,
                name: "",
                code: "",
                serialNo: "",
                categoryId: 0,
                defaultWarehouseId: 0,
                quantity: 0,
                photoUrl: null,
                assignedCount: 0,
                assignedUsers: [],
                fields: [],
            },
            document: {
                id: null,
                documentDefinitionId: null,
                description: "",
                filePath: null
            },
            selectedFile: null,
            newFieldId: null,
            newFieldValue: "",
            documentDefinitions: [],
            documents: [],
            inventories: [],
            inventoryFields: [],
            inventoryCategories: [],
            inventoryWarehouses: [],
        };
    },
    computed: {
        authControl() {
            return this.$store.getters.getAuthTanimlamalar;
        },
        documentList() {
            return this.documents;
        },
        documentDefinitionList() {
            return this.documentDefinitions;
        },
        inventoryList() {
            if (this.searchText) {
                return this.inventories.filter(item => {
                    return this.searchText
                        .toUpperCase()
                        .split(" ")
                        .every(v => item.name.toUpperCase().includes(v));
                });
            } else if (this.selectedCategory && this.selectedCategory != 0) {
                return this.inventories.filter(item => item.categoryId == this.selectedCategory);
            } else {
                return this.inventories;
            }
        },
        inventoryFieldList() {
            return this.inventoryFields;
        },
        inventoryCategoryList() {
            return this.inventoryCategories;
        },
        inventoryWarehouseList() {
            return this.inventoryWarehouses;
        },
        windowHeightSize() {
            if (this.windowHeight) {
                let height = this.windowHeight - 260;
                return "max-height:" + height + "px;overflow:auto;";
            } else {
                return "max-height:370px;overflow:auto;";
            }
        }
    },
    watch: {
        windowHeight(newHeight, oldHeight) {
            if (newHeight < 576) {
                //MOBİL
            } else {
                //WEB
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
        });
    },
    methods: {
        onResize() {
            this.windowHeight = window.innerHeight;
        },
        toDateFormat(str, format) {
            if (str.length > 9) {
                str = new Date(str);
            } else {
                str = new Date("1900-01-01 " + str.replace("Z", ""));
            }
            if (format == "gg.aa.yyyy ss:dd") {
                var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
                var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
                var yil = str.getFullYear();
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika =
                    str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
            } else if (format == "gg.aa.yyyy") {
                var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
                var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
                var yil = str.getFullYear();
                return yil + "-" + ay + "-" + gun;
            } else if (format == "ss:dd:ss") {
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika =
                    str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                var saniye =
                    str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
                return saat + ":" + dakika + ":" + saniye;
            } else if (format == "ss:dd") {
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika =
                    str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                return saat + ":" + dakika;
            }
        },
        changeField(event) {
            this.newFieldId = event.target.value;
        },
        changeCategory(event) {
            this.inventory.categoryId = event.target.value;
        },
        changeDefaultWarehouse(event) {
            this.inventory.defaultWarehouseId = event.target.value;
        },
        getDocumentDefinitionName(documentDefinitionId) {
            let definition = this.documentDefinitions.find(
                d => d.id === documentDefinitionId
            );
            return definition ? definition.name : "";
        },
        getInventoryCategoryName(categoryId) {
            let category = this.inventoryCategories.find(c => c.id === categoryId);
            return category ? category.name : "";
        },
        newDocument() {
            this.document.id = null;
            this.document.documentDefinitionId = null;
            this.document.description = "";
            this.document.filePath = null;
            $('#modal-document').modal('show');
        },
        uploadDocumentDialog(document) {
            this.document.id = document.id;
            this.document.documentDefinitionId = document.documentDefinitionId;
            this.document.description = document.description;
            this.document.filePath = document.filePath;
            $('#modal-document-file').modal('show');
        },
        getDocument(document) {
            this.document.id = document.id;
            this.document.documentDefinitionId = document.documentDefinitionId;
            this.document.description = document.description;
            this.document.filePath = document.filePath;
            $('#modal-document').modal('show');
        },
        uploadFile() {
            var fileName = document.getElementById("fileName").value;
            var idxDot = fileName.lastIndexOf(".") + 1;
            var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
            if (extFile == "zip" || extFile == "pdf" || extFile == "doc" || extFile == "docx" || extFile == "xls" || extFile == "xlsx" || extFile == "png" || extFile == "jpg" || extFile == "jpeg") {
                if (this.$refs.file.files[0].size > 29000000) { //29 MB
                    alertify.warning(this.$ml.with("29 MB").get("alerts.fileSizeIsTooHigh"));
                    this.fileId = null;
                    this.$refs.file.value = "";
                    return;
                }
                this.selectedFile = this.$refs.file.files[0];
            } else {
                alertify.warning(
                    this.$ml.get("alerts.pleaseCheckTheFileFormat")
                );
                return;
            }
        },
        async submitFile() {
            if (this.selectedFile) {
                this.isLoading = true;
                const formData = new FormData();
                formData.append("file", this.selectedFile);
                const responseFile = await this.$axios
                    .patch(
                        "/Inventory/AddDocumentFile/" +
                        this.document.id,
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    )
                    .then((response) => {
                        alertify.success(this.$ml.get("alerts.fileUploadSuccessfull"));
                        this.getDocuments();
                        $("#modal-document-file").modal("hide");
                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoadingDetail = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoadingDetail = false;
                                return;
                            }
                        }
                    });
            } else {
                this.isLoading = false;
                alertify.warning(this.$ml.get("alerts.pleaseSelectFile"));
                return;
            }
        },
        async deleteDocument(documentId) {
            try {
                this.isLoadingDetail = true;
                let id = documentId;
                const response = await this.$axios
                    .delete("/Inventory/Document/" + id)
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoadingDetail = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoadingDetail = false;
                                return;
                            }
                        }
                    });
                this.getDocuments();
                alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
                this.isLoadingDetail = false;
            } catch (error) {
                alertify.error("Hata Oluştu : " + error);
                this.isLoadingDetail = false;
            }
        },
        async saveDocument() {
            if (this.document.documentDefinitionId == null) {
                alertify.warning(this.$ml.get('alerts.pleaseSelectADocumentDefinition'));
                return;
            }
            this.isLoadingDetail = true;
            if (this.document.id == null) {
                try {
                    let document2 = this.document;
                    const response = await this.$axios
                        .post("/Inventory/Document", {
                            inventoryId: this.inventory.id,
                            documentDefinitionId: document2.documentDefinitionId,
                            description: document2.description
                        })
                        .catch(error => {
                            if (error.response) {
                                if (error.response.status == 401) {
                                    this.$store.dispatch("logout");
                                }
                            } else {
                                if (
                                    error.message == "Network Error" ||
                                    error.message == "Error: Network Error"
                                ) {
                                    alertify.error(this.$ml.get('errors.connectionError'));
                                    this.isLoadingDetail = false;
                                    return;
                                } else {
                                    console.error(error);
                                    alertify.error(error.message);
                                    this.isLoadingDetail = false;
                                    return;
                                }
                            }
                        });
                    let id = response.data.id;
                    if (response.status == 200) {
                        alertify.success(this.$ml.get('alerts.savedSuccessfully'));
                    } else {
                        alertify.error(response.message);
                    }
                    this.getDocuments();
                    this.isLoadingDetail = false;
                } catch (error) {
                    console.error(error);
                    alertify.error(error.message);
                    this.isLoadingDetail = false;
                }
            } else {
                //GÜNCELLE
                try {
                    let document2 = this.document;
                    const response = await this.$axios
                        .put("/Inventory/Document/" + document2.id, {
                            documentDefinitionId: document2.documentDefinitionId,
                            description: document2.description
                        })
                        .catch(error => {
                            if (error.response) {
                                if (error.response.status == 401) {
                                    this.$store.dispatch("logout");
                                }
                            } else {
                                if (
                                    error.message == "Network Error" ||
                                    error.message == "Error: Network Error"
                                ) {
                                    alertify.error(this.$ml.get('errors.connectionError'));
                                    this.isLoadingDetail = false;
                                    return;
                                } else {
                                    console.error(error);
                                    alertify.error(error.message);
                                    this.isLoadingDetail = false;
                                    return;
                                }
                            }
                        });
                    if (response.status == 200) {
                        alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
                    } else {
                        alertify.error(response.message);
                    }
                    this.getDocuments();
                    this.isLoadingDetail = false;
                } catch (error) {
                    console.error(error);
                    alertify.error(error);
                    this.isLoadingDetail = false;
                }
            }
        },
        async getDocuments() {
            try {
                this.isLoading = true;
                this.documents = [];
                const response = await this.$axios
                    .get("/Inventory/Documents/" + this.inventory.id)
                    .then(response => {
                        this.documents = response.data;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async getDocumentDefinitions() {
            try {
                this.isLoading = true;
                this.documentDefinitions = [];
                const response = await this.$axios
                    .get("/DocumentDefinition/GetAll")
                    .then(response => {
                        this.documentDefinitions = response.data;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async addField() {
            if (this.newFieldId == 0 || this.newFieldId == null) {
                alertify.warning(this.$ml.get('alerts.pleaseSelect'));
                return;
            }
            if (this.newFieldValue == null || this.newFieldValue == "") {
                alertify.warning(this.$ml.get('alerts.pleaseEnterAValue'));
                return;
            }
            this.isLoadingDetail = true;
            const response = await this.$axios
                .post("/Inventory/AddFieldValue/" + this.inventory.id, {
                    fieldId: this.newFieldId,
                    value: this.newFieldValue
                })
                .then(response => {
                    if (response.status == 200) {
                        alertify.success(this.$ml.get('alerts.savedSuccessfully'));
                        this.getInventory(this.inventory.id);
                        this.newFieldId = 0;
                        this.newFieldValue = "";
                    } else {
                        alertify.error(response.message);
                    }
                    this.isLoadingDetail = false;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("logout");
                        }
                    } else {
                        if (
                            error.message == "Network Error" ||
                            error.message == "Error: Network Error"
                        ) {
                            alertify.error(this.$ml.get('errors.connectionError'));
                            this.isLoadingDetail = false;
                            return;
                        } else {
                            console.error(error);
                            alertify.error(error.message);
                            this.isLoadingDetail = false;
                            return;
                        }
                    }
                });
        },
        async deleteField(fieldId) {
            try {
                this.isLoadingDetail = true;
                let id = fieldId;
                const response = await this.$axios
                    .delete("/Inventory/RemoveFieldValue/" + this.inventory.id + "?inventoryFieldValueId=" + id)
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoadingDetail = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoadingDetail = false;
                                return;
                            }
                        }
                    });
                this.getInventory(this.inventory.id);
                alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
                this.isLoadingDetail = false;
            } catch (error) {
                alertify.error("Hata Oluştu : " + error);
                this.isLoadingDetail = false;
            }
        },
        newInventory() {
            this.isLoadingDetail = true;
            this.inventory.id = null;
            this.inventory.name = "";
            this.inventory.code = "";
            this.inventory.serialNo = "";
            this.inventory.categoryId = 0;
            this.inventory.defaultWarehouseId = 0;
            this.inventory.quantity = 0;
            this.inventory.photoUrl = null;
            this.documents = [];
            $("#temel-bilgiler").addClass("active");
            $("#temel-bilgiler-tab").addClass("active");
            $("#ozellikler").removeClass("active");
            $("#ozellikler-tab").removeClass("active");
            $("#belgeler").removeClass("active");
            $("#belgeler-tab").removeClass("active");
            $("#zimmetlenen-kisiler").removeClass("active");
            $("#zimmetlenen-kisiler-tab").removeClass("active");
            this.isLoadingDetail = false;
        },
        async addPhoto() {
            if (this.inventory.id == null) {
                alertify.warning(this.$ml.get("alerts.pleaseSelect"));
                return;
            } else {
                var fileName = document.getElementById("image").value;
                var idxDot = fileName.lastIndexOf(".") + 1;
                var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
                if (extFile == "png" || extFile == "jpg" || extFile == "jpeg" || extFile == "gif") {
                    if (this.$refs.imageFile.files[0].size > 29000000) { //29 MB
                        alertify.warning(this.$ml.with("29 MB").get("alerts.fileSizeIsTooHigh"));
                        this.fileId = null;
                        this.$refs.imageFile.value = "";
                        return;
                    }
                    const formData = new FormData();
                    formData.append("file", this.$refs.imageFile.files[0]);
                    const responseImage = this.$axios
                        .patch("/Inventory/AddPhoto/" + this.inventory.id, formData)
                        .then(result2 => {
                            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                            this.getInventory(this.inventory.id);
                        });
                } else {
                    alertify.warning(
                        this.$ml.get("alerts.pleaseCheckTheFileFormat")
                    );
                    return;
                }
            }
        },
        async removeImage() {
            if (this.inventory.id == null) {
                alertify.warning(this.$ml.get("alerts.pleaseSelect"));
                return;
            } else {
                const responseImage = this.$axios
                    .delete("/Inventory/RemovePhoto/" + this.inventory.id)
                    .then(result => {
                        this.inventory.photoUrl = null;
                        alertify.success(
                            this.$ml.get("alerts.updatedSuccessfully")
                        );
                    });
            }
        },
        async deleteInventory() {
            try {
                this.isLoadingDetail = true;
                let id = this.inventory.id;
                const response = await this.$axios
                    .delete("/Inventory/" + id)
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 400) {
                                alertify.error("Silmek istenilen demirbaş kişi veya ziyaretçilere zimmet olarak tanımlı.");
                            }
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoadingDetail = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoadingDetail = false;
                                return;
                            }
                        }
                    });
                this.getInventories();
                this.newInventory();
                alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
                this.isLoadingDetail = false;
            } catch (error) {
                alertify.error("Hata Oluştu : " + error);
                this.isLoadingDetail = false;
            }
        },
        async saveInventory() {
            if (this.inventory.name == "") {
                alertify.warning(this.$ml.get('alerts.pleaseEnterAName'));
                return;
            }
            this.isLoadingDetail = true;
            if (this.inventory.id == null) {
                try {
                    let inventory2 = this.inventory;
                    const response = await this.$axios
                        .post("/Inventory", {
                            name: inventory2.name,
                            code: inventory2.code,
                            serialNo: inventory2.serialNo,
                            categoryId: inventory2.categoryId,
                            defaultWarehouseId: inventory2.defaultWarehouseId,
                            quantity: inventory2.quantity
                        })
                        .catch(error => {
                            if (error.response) {
                                if (error.response.status == 401) {
                                    this.$store.dispatch("logout");
                                }
                            } else {
                                if (
                                    error.message == "Network Error" ||
                                    error.message == "Error: Network Error"
                                ) {
                                    alertify.error(this.$ml.get('errors.connectionError'));
                                    this.isLoadingDetail = false;
                                    return;
                                } else {
                                    console.error(error);
                                    alertify.error(error.message);
                                    this.isLoadingDetail = false;
                                    return;
                                }
                            }
                        });
                    let id = response.data.id;
                    if (response.status == 200) {
                        alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                    } else {
                        alertify.error(response.message);
                    }
                    this.getInventories();
                    this.getInventory(id);
                    this.isLoadingDetail = false;
                } catch (error) {
                    console.error(error);
                    alertify.error(error.message);
                    this.isLoadingDetail = false;
                }
            } else {
                //GÜNCELLE
                try {
                    let inventory2 = this.inventory;
                    const response = await this.$axios
                        .put("/Inventory/" + inventory2.id, {
                            name: inventory2.name,
                            code: inventory2.code,
                            serialNo: inventory2.serialNo,
                            categoryId: inventory2.categoryId,
                            defaultWarehouseId: inventory2.defaultWarehouseId,
                            quantity: inventory2.quantity
                        })
                        .catch(error => {
                            if (error.response) {
                                if (error.response.status == 401) {
                                    this.$store.dispatch("logout");
                                }
                            } else {
                                if (
                                    error.message == "Network Error" ||
                                    error.message == "Error: Network Error"
                                ) {
                                    alertify.error(this.$ml.get('errors.connectionError'));
                                    this.isLoadingDetail = false;
                                    return;
                                } else {
                                    console.error(error);
                                    alertify.error(error.message);
                                    this.isLoadingDetail = false;
                                    return;
                                }
                            }
                        });
                    if (response.status == 200) {
                        alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
                    } else {
                        alertify.error(response.message);
                    }
                    this.getInventories();
                    this.isLoadingDetail = false;
                } catch (error) {
                    console.error(error);
                    alertify.error(error);
                    this.isLoadingDetail = false;
                }
            }
        },
        async getInventory(id) {
            try {
                this.isLoadingDetail = true;
                const response = await this.$axios
                    .get("/Inventory/" + id)
                    .then(response => {
                        this.inventory.id = id;
                        this.inventory.name = response.data.name;
                        this.inventory.code = response.data.code;
                        this.inventory.serialNo = response.data.serialNo;
                        this.inventory.categoryId = response.data.categoryId;
                        this.inventory.defaultWarehouseId = response.data.defaultWarehouseId;
                        this.inventory.quantity = response.data.quantity;
                        this.inventory.photoUrl = response.data.photoUrl;
                        this.inventory.assignedCount = response.data.assignedCount;
                        this.inventory.assignedUsers = response.data.assignedUsers;
                        this.inventory.fields = response.data.fields;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoadingDetail = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoadingDetail = false;
                                return;
                            }
                        }
                    });
                await this.getDocuments();
                this.isLoadingDetail = false;
            } catch (error) {
                console.error(error);
                alertify.error(error);
                this.isLoadingDetail = false;
            }
        },
        async getInventories() {
            try {
                this.isLoading = true;
                const response = await this.$axios
                    .get("/Inventory/Inventories")
                    .then(response => {
                        this.inventories = response.data;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async getInventoryWarehouses() {
            try {
                this.isLoading = true;
                const response = await this.$axios
                    .get("/InventoryWarehouse/GetAll")
                    .then(response => {
                        this.inventoryWarehouses = response.data;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async getInventoryCategories() {
            try {
                this.isLoading = true;
                const response = await this.$axios
                    .get("/InventoryCategory/GetAll")
                    .then(response => {
                        this.inventoryCategories = response.data;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async getInventoryFields() {
            try {
                this.isLoading = true;
                var fields = [];
                const response = await this.$axios
                    .get("/InventoryField/InventoryFields")
                    .then(response => {
                        fields = response.data;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get('errors.connectionError'));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.inventoryFields = fields;
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async getAuthControl() {
            if (this.authControl == 1) {
                alertify.warning(
                    this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage')
                );
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    async created() {
        await this.getAuthControl();
        await this.getInventories();
        await this.getInventoryFields();
        await this.getInventoryCategories();
        await this.getInventoryWarehouses();
        await this.getDocumentDefinitions();
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/inventoryManagement/Inventories.vue